<template>
  <common-layout-history-template :isBread="true" :breadHeading="'お気に入り物件リスト'">
    <template v-slot:body>
      <favorite-contents />
    </template>
  </common-layout-history-template>
</template>

<script>
import FavoriteContents from '@/components/favorite/FavoriteContents';
import CommonLayoutHistoryTemplate from '@/components/templates/CommonLayoutHistoryTemplate';

export default {
  name: 'Bookmark',
  components: {
    FavoriteContents,
    CommonLayoutHistoryTemplate,
  },
  data() {
    return {

    };
  },
  computed: {

  },
  created() {

  },
  methods: {

  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
</style>
